import React from 'react'
import PolicyText from './PolicyText.js';


export default function ConfirmedBookingRoom(props) {

    function pluralise(string, qty) {
        return qty + ' ' + string + (qty === 1 ? '' : 's');
    }

    function children(qty) {
        return qty === 0 ? '' : (qty === 1 ? ' 1 child' : (' ' + qty + ' children'));
    }

    return (

        <div>
            <div className='row'>
                <div className='col-7'>
                    <div className='image-container' >
                        <img src={props.bookingRoom.roomType.mainImageUrl} alt={props.bookingRoom.roomType.name} className='room-image-thumb' />

                    </div>
                </div>
                <div className='col-5 text-right'><small></small>

                </div>
            </div>
            <div className='row'>
                <div className='col-6'>
                    <small>{props.bookingRoom.roomType.name}<br />
                    </small>
                </div>
                <div className='col-6 text-right'>
                    <div>
                        <small>£{(+props.bookingRoom.charge).toFixed(2)}</small>

                    </div>
                    <div class="small text-danger text-right">
                        {props.bookingRoom.promotionCode && props.bookingRoom.promotionCode?.promoCode && "Promo: " + props.bookingRoom.promotionCode.promoCode + " applied"}
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-6'>
                    <small>{pluralise('adult', props.bookingRoom.adults) + children(props.bookingRoom.children)}<br />
                    </small>

                </div>
                <div className='col-6 text-right'>
                    <small>
                        {props.bookingRoom.ratePlan.name} <br />
                        {props.bookingRoom.mealPlan?.name}


                    </small>
                </div>

            </div>

            {
                props.showCancellationPolicy &&


                <div>
                    <PolicyText
                        policy={props.bookingRoom.cancellationPolicy}
                    />

                </div>
            }
            {
                props.showDepositPolicy &&

                <div>
                    <PolicyText
                        policy={props.bookingRoom.depositPolicy}
                    />

                </div>

            }

            <hr />
        </div>




    )
}